import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Mount-once helper that scrolls the window (and the page's first
 * scroll-container, if any) back to the top on every route change.
 *
 * Why both? Routing in this app preserves `<main>` across page swaps —
 * but several pages have their OWN inner `overflow-y-auto` containers
 * (BuildPath, KanjiFocus's content sections) which retain scrollY
 * across navigation. Resetting just `window` leaves those containers
 * mid-page; resetting just those containers misses the body scroll
 * on mobile. So we do both, defensively.
 *
 * Renders nothing. Place once near the top of the App component, INSIDE
 * the <BrowserRouter>.
 */
export default function ScrollToTopOnNav() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Skip when only the query param changes (e.g. ?tab=phonetic) —
    // the user is staying on the same page, scroll position should be
    // preserved so they can see the section they just clicked into.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.querySelectorAll("[data-scroll-container]")
      .forEach((el) => { el.scrollTop = 0; });
  }, [pathname]);
  return null;
}
